import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../config/axios';
import { formatError } from '../utils/errorHandler';
import Modal from './Modal';
import UserAssignPicker from './UserAssignPicker';

function WorkGroupAssignAllModal({
  isOpen,
  onClose,
  workGroup,
  assignableUsers,
  onAssigned
}) {
  const { t } = useTranslation(['tasks', 'common']);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const handleClose = () => {
    setSelectedAssignees([]);
    setError('');
    setResult(null);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!workGroup?.id || selectedAssignees.length === 0) {
      return;
    }
    setBusy(true);
    setError('');
    setResult(null);
    try {
      const response = await axios.post(`/api/work-groups/${workGroup.id}/assign-all`, {
        userIds: selectedAssignees.map((u) => u.id)
      });
      setResult(response.data.data);
      if (onAssigned) {
        await onAssigned(response.data.data);
      }
    } catch (err) {
      setError(formatError(err) || t('tasks:workGroupAssignAllFailed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={t('tasks:workGroupAssignAllTitle', { name: workGroup?.name || '' })}
      className="tasks-work-group-assign-modal"
    >
      <form onSubmit={handleSubmit}>
        <p className="tasks-work-group-assign-hint">
          {t('tasks:workGroupAssignAllHint')}
        </p>
        {error && <div className="error">{error}</div>}
        {result && (
          <div className="tasks-work-group-assign-result">
            {t('tasks:workGroupAssignAllResult', {
              updated: result.updated,
              skipped: result.skipped
            })}
          </div>
        )}
        <div className="form-group">
          <label>{t('tasks:assignToLabel')}</label>
          <UserAssignPicker
            users={assignableUsers}
            selectedUsers={selectedAssignees}
            onChange={setSelectedAssignees}
          />
        </div>
        <div className="modal-actions">
          <button type="button" className="btn btn-secondary" onClick={handleClose} disabled={busy}>
            {t('common:close', { defaultValue: 'Close' })}
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={busy || selectedAssignees.length === 0}
          >
            {busy ? t('tasks:workGroupAssignAllBusy') : t('tasks:workGroupAssignAll')}
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default WorkGroupAssignAllModal;
